import { useSerializedAccountData, useSerializedAccountRewardsData } from "@apis/accounts/useAccounts"
import { useParams } from "react-router"
import { InfoSection } from "@components/InfoSection/InfoSection"
import { EnergyImpact } from "@components/EnergyImpact/EnergyImpact"
import AccountTitle from "@components/AccountNew/AccountTitle/AccountTitle"
import { AccountTabs } from "./AccountTabs"

export const AccountPage = () => {
  const { account_id } = useParams() as { account_id: string }

  const { data: accountData, isPending: accountIsPending } =
    useSerializedAccountData(account_id)

  const { data: rewardsData, isPending: rewardsIsPending } =
    useSerializedAccountRewardsData(account_id)

  return (
    <div className="tw:flex tw:flex-col tw:gap-8">
      <div className="tw:grid tw:grid-cols-5 tw:gap-2">
        <AccountTitle classNames="tw:col-span-2" account_id={account_id} />
        <InfoSection
          title="Plan"
          actions={accountData?.planSection.actions ?? []}
          description_lines={accountData?.planSection.description_lines ?? []}
          isPending={accountIsPending}
          classNames="tw:col-span-1"
        />
        <InfoSection
          title="Rewards"
          actions={rewardsData?.rewardsSection.actions ?? []}
          description_lines={
            rewardsData?.rewardsSection.description_lines ?? []
          }
          isPending={rewardsIsPending}
          classNames="tw:col-span-1"
        />

        {account_id && <EnergyImpact account_id={account_id} />}
      </div>
      <div>
        <AccountTabs
          account_id={account_id}
          prospect_guid={accountData?.prospectData?.prospect_guid}
        />
      </div>
    </div>
  )
}
